<template>
  <div
    class="sli-cell"
    :class="`sli-span-${span}`"
  >
    <span class="sli-cell__label">{{ label }}</span>
    <div class="sli-fqs">
      <label
        class="sli-fqs__unit"
        :for="`${uid}-feddan`"
      >
        <span class="sli-fqs__cap">ف</span>
        <input
          :id="`${uid}-feddan`"
          :value="feddan"
          inputmode="numeric"
          type="text"
          autocomplete="off"
          :disabled="disabled"
          class="sli-cell__input text-center"
          @input="$emit('update:feddan', $event.target.value)"
        >
      </label>
      <label
        class="sli-fqs__unit"
        :for="`${uid}-qirat`"
      >
        <span class="sli-fqs__cap">ط</span>
        <input
          :id="`${uid}-qirat`"
          :value="qirat"
          inputmode="numeric"
          type="text"
          autocomplete="off"
          :disabled="disabled"
          class="sli-cell__input text-center"
          @input="$emit('update:qirat', $event.target.value)"
        >
      </label>
      <label
        class="sli-fqs__unit"
        :for="`${uid}-sahm`"
      >
        <span class="sli-fqs__cap">س</span>
        <input
          :id="`${uid}-sahm`"
          :value="sahm"
          inputmode="numeric"
          type="text"
          autocomplete="off"
          :disabled="disabled"
          class="sli-cell__input text-center"
          @input="$emit('update:sahm', $event.target.value)"
        >
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SliFqsInputs',
  props: {
    label: { type: String, default: 'المساحة (ف/ط/س)' },
    uid: { type: String, default: 'fqs' },
    span: { type: [Number, String], default: 2 },
    feddan: { type: [String, Number], default: '' },
    qirat: { type: [String, Number], default: '' },
    sahm: { type: [String, Number], default: '' },
    disabled: { type: Boolean, default: false },
  },
}
</script>

<style scoped>
.sli-fqs {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 4.5rem));
  gap: 8px;
  justify-content: start;
}
@media (max-width: 1199.98px) {
  .sli-fqs {
    grid-template-columns: repeat(3, minmax(3.25rem, 1fr));
    max-width: 18rem;
  }
}
@media (max-width: 575.98px) {
  .sli-fqs {
    max-width: none;
  }
}
.sli-fqs__unit {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0;
  min-width: 0;
}
.sli-fqs__cap {
  display: block;
  width: 100%;
  text-align: center;
  font-size: 11px;
  font-weight: 700;
  color: #06284D;
  line-height: 1.2;
  margin-bottom: 2px;
}
</style>
